import { IonButton } from "@ionic/react";
import { useState } from "react";
import { useHistory } from "react-router";
import { useRecoilState } from "recoil";
import { networkConnectionStatus } from "../../data/atoms";
import { ActionType } from "../../models/Enums";
import {
  EnableDisablePatientRtm,
  SaveConsentForm,
} from "../../services/AuthServices";
import { localDateTime } from "../../utils/sharedFunction";

interface Props {
  setRemoteTherapeuticMonitoring: Function;
  patientName: string;
  onClose: () => void;
  isDisabled?: boolean;
  onEnableClick?: () => void;
}

const RemoteTherapeuticMonitoringModal: React.FC<Props> = ({
  setRemoteTherapeuticMonitoring,
  patientName,
  onClose,
  isDisabled,
  onEnableClick,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus,
  );
  const history = useHistory();

  const enableDisablePatientRtm = async (
    isNewEpisode: boolean,
    isRtmReenable: boolean,
  ) => {
    if (!isButtonDisabled) {
      setIsButtonDisabled(true);
      if (!navigator.onLine) {
        setShowNetWorkRecoil({ isShown: true });
        return;
      }
      try {
        await EnableDisablePatientRtm({
          PatientId: localStorage.getItem("patientServerID"),
          EncryptedServerId: localStorage.getItem("EncryptedServerId"),
          IsPatientRTMEnabled: false,
          LocalDateTime: localDateTime(),
          IsNewEpisode: isNewEpisode,
          IsRtmReenable: isRtmReenable,
          MasterUserId: JSON.parse(localStorage.getItem("patientMasterID")!),
          MobilePhone: localStorage.getItem("patientMobileNumber") ?? "",
        }).then(async function (response: any) {
          console.log("Response: ", response);
          setIsButtonDisabled(false);
          if (response?.data?.dbResponse?.id > 0 && onClose) {
            console.log("Response: ", response);
            sessionStorage.setItem("isPatientRtmTrue", "false");
            onClose();
          }
        });
      } catch (error) {
        history.push("/confirmation", {
          actionType: ActionType.FailureAPIResponse,
        });
        console.error(error);
      }
    }
  };

  // const handleSubmit = async () => {
  //   if (!isButtonDisabled) {
  //     setIsButtonDisabled(true);
  //     if (!navigator.onLine) {
  //       setShowNetWorkRecoil({ isShown: true });
  //       return;
  //     }
  //     try {
  //       await SaveConsentForm({
  //         PatientId: localStorage.getItem("patientServerID"),
  //         EncryptedServerId: localStorage.getItem("EncryptedServerId"),
  //         MobilePhone: null,
  //         Email: null,
  //         IsPatientRTMEnabled: false,
  //         StartDate: null,
  //         ExerciseStartTime: null,
  //         ExerciseStartTimeUtc: null,
  //         localDateTime: localDateTime(),
  //       }).then(async function (response: any) {
  //         setIsButtonDisabled(false);
  //         if (response.data.id > 0 && onClose) {
  //           console.log("Response: ", response);
  //           onClose();
  //         }
  //       });
  //     } catch (error) {
  //       history.push("/confirmation", {
  //         actionType: ActionType.FailureAPIResponse,
  //       });
  //       console.error(error);
  //     }
  //   }
  // };

  return (
    <>
      <div className="py-32 ph-42 text-center flex-column">
        {isDisabled ? (
          <svg
            className="mb-24"
            xmlns="http://www.w3.org/2000/svg"
            width="161"
            height="160"
            viewBox="0 0 161 160"
            fill="none"
          >
            <path
              d="M120.499 53.333C126.392 53.3332 131.165 58.1068 131.165 64V149.333C131.165 155.226 126.392 160 120.499 160H40.499C34.6057 160 29.832 155.226 29.832 149.333V64C29.832 58.1067 34.6057 53.333 40.499 53.333H120.499ZM93.832 144C92.3655 144 91.1652 145.199 91.165 146.666C91.165 148.133 92.3654 149.333 93.832 149.333C95.2987 149.333 96.499 148.133 96.499 146.666C96.4988 145.199 95.2986 144 93.832 144ZM104.499 144C103.032 144 101.832 145.199 101.832 146.666C101.832 148.133 103.032 149.333 104.499 149.333C105.966 149.333 107.165 148.133 107.165 146.666C107.165 145.2 105.965 144 104.499 144ZM115.165 144C113.699 144 112.499 145.2 112.499 146.666C112.499 148.133 113.699 149.333 115.165 149.333C116.632 149.333 117.832 148.133 117.832 146.666C117.832 145.199 116.632 144 115.165 144ZM40.499 58.666C37.5656 58.666 35.165 61.0666 35.165 64V133.333H125.832V64C125.832 61.0667 123.432 58.6662 120.499 58.666H40.499ZM147.167 0C154.527 0.000163119 160.5 5.97326 160.5 13.333V114.667C160.5 122.027 154.527 128 147.167 128H139.167C137.7 128 136.5 126.8 136.5 125.333C136.5 123.866 137.7 122.667 139.167 122.667H147.167C151.567 122.667 155.167 119.067 155.167 114.667V26.668H5.83301V114.667C5.83318 119.067 9.4333 122.667 13.833 122.667H21.833C23.2996 122.667 24.4998 123.866 24.5 125.333C24.5 126.8 23.2997 128 21.833 128H13.833C6.47326 128 0.50017 122.027 0.5 114.667V13.333C0.500177 5.97327 6.47327 0.000177304 13.833 0H147.167ZM68.5 78C71.59 78 74.0996 80.5212 74.0996 83.625V98.0889H86.9004V83.625C86.9004 80.5212 89.41 78 92.5 78H94.0996C97.1896 78 99.7002 80.5212 99.7002 83.625V85.2324H102.1C105.19 85.2324 107.7 87.7536 107.7 90.8574V98.0889H110.1C111.43 98.0889 112.5 99.1641 112.5 100.5C112.5 101.836 111.43 102.911 110.1 102.911H107.7V110.143C107.7 113.246 105.19 115.768 102.1 115.768H99.7002V117.375C99.7002 120.479 97.1896 123 94.0996 123H92.5C89.41 123 86.9004 120.479 86.9004 117.375V102.911H74.0996V117.375C74.0996 120.479 71.59 123 68.5 123H66.9004C63.8104 123 61.2998 120.479 61.2998 117.375V115.768H58.9004C55.8104 115.768 53.2998 113.246 53.2998 110.143V102.911H50.9004C49.5704 102.911 48.5 101.836 48.5 100.5C48.5 99.1641 49.5704 98.0889 50.9004 98.0889H53.2998V90.8574C53.2998 87.7536 55.8104 85.2324 58.9004 85.2324H61.2998V83.625C61.2998 80.5212 63.8104 78 66.9004 78H68.5ZM66.9004 82.8213C66.4604 82.8213 66.0996 83.183 66.0996 83.625V117.375C66.0996 117.817 66.4604 118.179 66.9004 118.179H68.5C68.94 118.179 69.2998 117.817 69.2998 117.375V83.625C69.2998 83.183 68.94 82.8213 68.5 82.8213H66.9004ZM92.5 82.8213C92.06 82.8213 91.7002 83.183 91.7002 83.625V117.375C91.7002 117.817 92.06 118.179 92.5 118.179H94.0996C94.5396 118.179 94.9004 117.817 94.9004 117.375V83.625C94.9004 83.183 94.5396 82.8213 94.0996 82.8213H92.5ZM58.9004 90.0537C58.4604 90.0537 58.0996 90.4155 58.0996 90.8574V110.143C58.0996 110.585 58.4604 110.946 58.9004 110.946H61.2998V90.0537H58.9004ZM99.7002 110.946H102.1C102.54 110.946 102.9 110.585 102.9 110.143V90.8574C102.9 90.4155 102.54 90.0537 102.1 90.0537H99.7002V110.946ZM16.501 10.667C15.0344 10.667 13.8342 11.8665 13.834 13.333C13.834 14.7997 15.0343 16 16.501 16C17.9676 15.9999 19.168 14.7996 19.168 13.333C19.1678 11.8665 17.9675 10.6671 16.501 10.667ZM27.168 10.667C25.7014 10.667 24.5012 11.8665 24.501 13.333C24.501 14.7997 25.7013 16 27.168 16C28.6344 15.9998 29.834 14.7995 29.834 13.333C29.8338 11.8666 28.6343 10.6672 27.168 10.667ZM37.834 10.667C36.3675 10.6671 35.1681 11.8666 35.168 13.333C35.168 14.7996 36.3674 15.9999 37.834 16C39.3007 16 40.501 14.7997 40.501 13.333C40.5008 11.8665 39.3006 10.667 37.834 10.667Z"
              fill="#802392"
            />
          </svg>
        ) : (
          <svg
            className="mb-24"
            xmlns="http://www.w3.org/2000/svg"
            width="211"
            height="168"
            viewBox="0 0 211 168"
            fill="none"
          >
            <path
              d="M147.167 0.5H13.8333C6.47333 0.5 0.5 6.47333 0.5 13.8333V115.167C0.5 122.527 6.47333 128.5 13.8333 128.5H21.8333C23.3 128.5 24.5 127.3 24.5 125.833C24.5 124.367 23.3 123.167 21.8333 123.167H13.8333C9.43338 123.167 5.83333 119.567 5.83333 115.167V27.1675H155.167V115.167C155.167 119.567 151.567 123.167 147.167 123.167H139.167C137.7 123.167 136.5 124.367 136.5 125.833C136.5 127.3 137.7 128.5 139.167 128.5H147.167C154.527 128.5 160.5 122.527 160.5 115.167V13.8333C160.5 6.47333 154.527 0.5 147.167 0.5ZM16.5009 16.5C15.0342 16.5 13.8342 15.3 13.8342 13.8333C13.8342 12.3667 15.0342 11.1667 16.5009 11.1667C17.9675 11.1667 19.1675 12.3667 19.1675 13.8333C19.1675 15.3 17.9675 16.5 16.5009 16.5ZM27.1675 16.5C25.7008 16.5 24.5009 15.3 24.5009 13.8333C24.5009 12.3667 25.7008 11.1667 27.1675 11.1667C28.6342 11.1667 29.8342 12.3667 29.8342 13.8333C29.8342 15.3 28.6342 16.5 27.1675 16.5ZM37.8342 16.5C36.3675 16.5 35.1675 15.3 35.1675 13.8333C35.1675 12.3667 36.3675 11.1667 37.8342 11.1667C39.3009 11.1667 40.5009 12.3667 40.5009 13.8333C40.5009 15.3 39.3009 16.5 37.8342 16.5Z"
              fill="#898989"
            />
            <path
              d="M120.499 53.833H40.4987C34.6054 53.833 29.832 58.6064 29.832 64.4997V149.833C29.832 155.726 34.6054 160.5 40.4987 160.5H120.499C126.392 160.5 131.165 155.726 131.165 149.833V64.4997C131.165 58.6064 126.392 53.833 120.499 53.833ZM93.832 149.833C92.3654 149.833 91.1654 148.633 91.1654 147.166C91.1654 145.7 92.3654 144.5 93.832 144.5C95.2987 144.5 96.4987 145.7 96.4987 147.166C96.4987 148.633 95.2987 149.833 93.832 149.833ZM104.499 149.833C103.032 149.833 101.832 148.633 101.832 147.166C101.832 145.7 103.032 144.5 104.499 144.5C105.965 144.5 107.165 145.7 107.165 147.166C107.165 148.633 105.965 149.833 104.499 149.833ZM115.165 149.833C113.699 149.833 112.499 148.633 112.499 147.166C112.499 145.7 113.699 144.5 115.165 144.5C116.632 144.5 117.832 145.7 117.832 147.166C117.832 148.633 116.632 149.833 115.165 149.833ZM125.832 133.833H35.1654V64.4997C35.1654 61.5663 37.5653 59.1663 40.4987 59.1663H120.499C123.432 59.1663 125.832 61.5663 125.832 64.4997V133.833Z"
              fill="#898989"
            />
            <path
              d="M60.8 80.125C60.8 77.0212 63.31 74.5 66.4 74.5H68C71.09 74.5 73.6 77.0212 73.6 80.125V94.5893H86.4V80.125C86.4 77.0212 88.91 74.5 92 74.5H93.6C96.69 74.5 99.2 77.0212 99.2 80.125V81.7321H101.6C104.69 81.7321 107.2 84.2533 107.2 87.3571V94.5893H109.6C110.93 94.5893 112 95.6641 112 97C112 98.3359 110.93 99.4107 109.6 99.4107H107.2V106.643C107.2 109.747 104.69 112.268 101.6 112.268H99.2V113.875C99.2 116.979 96.69 119.5 93.6 119.5H92C88.91 119.5 86.4 116.979 86.4 113.875V99.4107H73.6V113.875C73.6 116.979 71.09 119.5 68 119.5H66.4C63.31 119.5 60.8 116.979 60.8 113.875V112.268H58.4C55.31 112.268 52.8 109.747 52.8 106.643V99.4107H50.4C49.07 99.4107 48 98.3359 48 97C48 95.6641 49.07 94.5893 50.4 94.5893H52.8V87.3571C52.8 84.2533 55.31 81.7321 58.4 81.7321H60.8V80.125ZM65.6 81.7321V84.1429V109.857V112.268V113.875C65.6 114.317 65.96 114.679 66.4 114.679H68C68.44 114.679 68.8 114.317 68.8 113.875V80.125C68.8 79.683 68.44 79.3214 68 79.3214H66.4C65.96 79.3214 65.6 79.683 65.6 80.125V81.7321ZM60.8 86.5536H58.4C57.96 86.5536 57.6 86.9152 57.6 87.3571V106.643C57.6 107.085 57.96 107.446 58.4 107.446H60.8V86.5536ZM94.4 109.857V84.1429V81.7321V80.125C94.4 79.683 94.04 79.3214 93.6 79.3214H92C91.56 79.3214 91.2 79.683 91.2 80.125V113.875C91.2 114.317 91.56 114.679 92 114.679H93.6C94.04 114.679 94.4 114.317 94.4 113.875V112.268V109.857ZM101.6 107.446C102.04 107.446 102.4 107.085 102.4 106.643V87.3571C102.4 86.9152 102.04 86.5536 101.6 86.5536H99.2V107.446H101.6Z"
              fill="#898989"
            />
            <path
              d="M158.993 69.9697C184.465 69.9698 205.115 90.6195 205.115 116.092C205.115 141.564 184.465 162.213 158.993 162.213C133.521 162.213 112.871 141.564 112.871 116.092C112.871 90.6195 133.521 69.9697 158.993 69.9697Z"
              fill="#802392"
            />
            <path
              d="M158.993 69.9697L158.993 64.9697H158.993V69.9697ZM205.115 116.092L210.115 116.092V116.092H205.115ZM158.993 162.213V167.213H158.993L158.993 162.213ZM112.871 116.092H107.871V116.092L112.871 116.092ZM158.993 69.9697L158.993 74.9697C181.704 74.9698 200.115 93.3809 200.115 116.092H205.115H210.115C210.115 87.8581 187.227 64.9698 158.993 64.9697L158.993 69.9697ZM205.115 116.092L200.115 116.092C200.115 138.802 181.704 157.213 158.993 157.213L158.993 162.213L158.993 167.213C187.227 167.213 210.115 144.325 210.115 116.092L205.115 116.092ZM158.993 162.213V157.213C136.282 157.213 117.871 138.802 117.871 116.092L112.871 116.092L107.871 116.092C107.871 144.326 130.76 167.213 158.993 167.213V162.213ZM112.871 116.092H117.871C117.871 93.3809 136.282 74.9697 158.993 74.9697V69.9697V64.9697C130.759 64.9697 107.871 87.8581 107.871 116.092H112.871Z"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M141.894 98.9935C143.695 97.1923 146.615 97.1923 148.416 98.9935L176.089 126.666C177.89 128.467 177.89 131.388 176.089 133.189C174.288 134.99 171.368 134.99 169.567 133.189L141.894 105.516C140.093 103.715 140.093 100.795 141.894 98.9935Z"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M176.089 98.9935C177.891 100.795 177.891 103.715 176.089 105.516L148.416 133.189C146.615 134.99 143.695 134.99 141.894 133.189C140.093 131.388 140.093 128.468 141.894 126.666L169.567 98.9935C171.368 97.1923 174.288 97.1923 176.089 98.9935Z"
              fill="white"
            />
          </svg>
        )}

        {isDisabled ? (
          <>
            <p className="generic-heading-32 fw-700 mb-24">
              Enable Remote Therapeutic Monitoring?
            </p>
            <p className="generic-heading-32 fw-400 mb-24">
              It looks like RTM isn’t turned on yet. Do you want to enable it
              now?
            </p>
          </>
        ) : (
          <p className="generic-heading-32 fw-700 mb-24">
            Are you sure you want to disable Remote <br /> Therapeutic
            Monitoring for {patientName}?
          </p>
        )}

        <div className="d-flex justify-content-center w-100 gap-24">
          <IonButton
            placeholder={undefined}
            className="generic-btn-outline mb-0 h-64 fz-26"
            onClick={() => {
              setRemoteTherapeuticMonitoring(false);
            }}
          >
            {" "}
            {isDisabled ? "Skip" : "Cancel"}
          </IonButton>
          <IonButton
            placeholder={undefined}
            className="generic-btn mb-0 h-64 fz-26"
            onClick={() => {
              console.log("isDisabled", isDisabled);
              console.log("onEnableClick", onEnableClick);
              if (isDisabled && onEnableClick) {
                onEnableClick();
              } else {
                enableDisablePatientRtm(true, false);
              }
            }}
          >
            {" "}
            {isDisabled ? "Enable" : "Disable"}
          </IonButton>
        </div>
      </div>
    </>
  );
};
export default RemoteTherapeuticMonitoringModal;
